<template>
	<transition name="modal">
		<div class="modal-mask" v-show="show">
			<div class="modal-container">
				<div class="modal-header">
					<h3>Importar histórico</h3>
				</div>
				<div class="modal-body">
					<div class="row">
						<div class="col-md-12">
							<div class="form-group">
								<label>Selecione o paciente para o qual deseja vincular este histórico</label>
								<select-paciente ref="selectPacienteRef" @setPacienteSelecionado="(paciente)=>{setPacienteSelecionado(paciente)}"></select-paciente>
							</div>
						</div>
					</div>
				</div>
				<div class="modal-footer">
					<div class="text-right" style="float:right">
						<button class="btn btn-default" @click="close()">
													<i class="fa fa-close"></i> Fechar
												</button>
						<button @click="confirmar()" class="btn btn-primary">
												<span class="fa fa-check"></span> Confirmar
											</button>
					</div>
				</div>
			</div>
		</div>
	</transition>
</template>

<script>
	import axios from "axios"; // Cliente para requisição http
	import selectPaciente from '@/components/cadastros/pacientes/selectPaciente';
	export default {
		props: ["show", "cdPessoa"],
		filters: {

		},
		data: () => ({
			paciente: {},
		}),
		mounted() {

		},
		methods: {
			confirmar() {
				if (this.isEmpty(this.paciente)) {
					this.$swal({
						type: "warning",
						title: "Atenção!",
						text: "É necessário selecionar um paciente!",
					});
					return;
				}

				this.$swal({
					title: 'Vincular este histórico ao paciente ' + this.paciente.nome + '?',
					text: 'Esta ação não poderá ser desfeita.',
					type: 'question',
					showCancelButton: true,
					confirmButtonColor: '#3085d6',
					cancelButtonColor: '#d33',
					confirmButtonText: '<i class="fa fa-check"></i> Confirmar',
					cancelButtonText: '<i class="fa fa-times"></i> Cancelar',
					reverseButtons: true
				}).then((result) => {
					if (result.value) {
						this.$swal({
							title: "Importando, aguarde...",
							text: "Esta ação pode demorar um pouco.",
							imageUrl: "/static/img/Rolling-green.gif",
							showConfirmButton: false,
							allowOutsideClick: false
						});
						let dados = {
							cd_pessoa: this.$props.cdPessoa,
							paciente_id: this.paciente.id
						}
						axios.post(`${this.$store.state.serverURI}/api/cadastros/pacientes/importarHistorico`, dados, this.$store.getters.getHeaderAuth)
							.then(response => {
								this.$swal({
									type: "success",
									title: "Histórico importado com sucesso!",
									showConfirmButton: false,
									timer: 1500
								});
								this.$emit('historicoImportado');
							}).catch(() => {
								this.$swal({
									type: "error",
									title: "Houve uma falha!",
									text: "Entre em contato com o administrador do sistema.",
								});
							});
					}
				});
			},
			setPacienteSelecionado(paciente) {
				this.paciente = paciente;
			},
			close() {
				this.$emit('close');
				this.paciente = {};
				this.$refs.selectPacienteRef.limpar()
			},
			isEmpty(objeto) {
				return Object.values(objeto).every(valor => valor === '');
			},
		},
		watch: {

		},
		components: {
			selectPaciente,
		}
	};
</script>

<style scoped>
	* {
		box-sizing: border-box;
	}

	.modal-mask {
		position: fixed;
		z-index: 1000;
		top: 0;
		left: 0;
		width: 100%;
		height: 100%;
		background-color: rgba(0, 0, 0, 0.5);
		transition: opacity 0.3s ease;
	}

	.modal-container {
		width: 40%;
		margin: 40px auto 0;
		padding: 10px;
		background-color: #fff;
		border-radius: 2px;
		box-shadow: 0 2px 8px rgba(0, 0, 0, 0.33);
		transition: all 0.3s ease;
		font-family: Helvetica, Arial, sans-serif;
	}

	.modal-header h3 {
		margin-top: 0;
		color: #333;
	}

	.modal-body {
		margin: 10px 0;
	}

	.text-right {
		text-align: right;
	}

	.form-label {
		display: block;
		margin-bottom: 1em;
	}

	.form-label>.form-control {
		margin-top: 0.5em;
	}

	.form-control {
		display: block;
		width: 100%;
		padding: 0.5em 1em;
		line-height: 1.5;
		border: 1px solid #ddd;
	}


	/*
									 * The following styles are auto-applied to elements with
									 * transition="modal" when their visibility is toggled
									 * by Vue.js.
									 *
									 * You can easily play with the modal transition by editing
									 * these styles.
									 */

	.modal-enter {
		opacity: 0;
	}

	.modal-leave-active {
		opacity: 0;
	}

	.modal-enter .modal-container,
	.modal-leave-active .modal-container {
		-webkit-transform: scale(1.1);
		transform: scale(1.1);
	}

	.modal {
		display: block !important;
		/* I added this to see the modal, you don't need this */
	}


	/* Important part */

	.modal-dialog {
		overflow-y: initial !important;
	}

	.modal-body {
		height: 150px;
		overflow-y: auto;
	}
</style>



// WEBPACK FOOTER //
// modalImportarHistorico.vue?0cc12a62